import { UnauthorizedError } from '@debbie/common/dist/util/errors.js';
import * as notifications from '@debbie/cortex/dist/notifications.js';
export const getErrorMessage = (err) => err != null &&
    typeof err === 'object' &&
    'message' in err &&
    typeof err.message === 'string'
    ? err.message
    : null;
export const errorNotification = (lang, err, action, identifier, additionalMessage) => {
    const errorTextMap = {
        any: lang.misc.errorPerforming,
        delete: lang.misc.errorDeleting,
        update: lang.misc.errorUpdating,
        create: lang.misc.errorCreating,
    };
    const errorMessage = `${errorTextMap[action]} ${identifier}`;
    const error = getErrorMessage(err);
    console.error(errorMessage, err);
    if (err instanceof UnauthorizedError) {
        notifications.notification({
            title: lang.misc.error,
            theme: 'error',
            subtitle: `${lang.errors.unauthorizedError}:\n${errorMessage}`,
        });
        return;
    }
    notifications.notification({
        title: lang.misc.error,
        theme: 'error',
        subtitle: additionalMessage
            ? `${errorMessage}: ${additionalMessage}`
            : error
                ? `${errorMessage}: ${error}`
                : errorMessage,
    });
};
export const successNotification = (lang, action, identifier, message) => {
    const successTextMap = {
        delete: lang.misc.successDeleting,
        update: lang.misc.successUpdating,
        create: lang.misc.successCreating,
    };
    const capitalizedIdentifier = identifier.charAt(0).toUpperCase() + identifier.slice(1);
    const successMessage = `${capitalizedIdentifier} ${successTextMap[action]}`;
    notifications.notification({
        title: successMessage,
        theme: 'success',
        subtitle: message,
    });
};
//# sourceMappingURL=errors.js.map